import { io } from 'socket.io-client';

let _socket = null;

export function initSocket(token) {
  if (_socket) return _socket;
  _socket = io(process.env.REACT_APP_SOCKET_URL || 'http://localhost:5001', {
    auth: { token }
  });
  return _socket;
}

export function getSocket() {
  return _socket;
}

export function disconnectSocket() {
  _socket?.disconnect();
  _socket = null;
}
